import { css } from '@emotion/css'

import { getThemeColors, shorthandHelper, mediaQueryHelper, hexToRgba } from '@offerzen/pinata-shame'

import colors from '../../lib/themes/colors'
import { borderRadius, spacing, fontSize, fontFamily, breakpoint, lineHeight } from '../../lib/styles'

const styles = {
  container: css({
    width: 240,
    maxWidth: '100%',
  }),

  wrapper: css({
    position: 'relative',
    borderRadius: borderRadius.default,
    border: `1px solid ${colors.grayChateau}`,
    height: 48,
    width: '100%',
    boxSizing: 'border-box',

    [mediaQueryHelper(breakpoint.phone)]: {
      height: 40,
    },
  }),

  wrapperError: css({
    borderColor: colors.mandy,

    '&:focus-within': {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`,
    },
  }),

  input: css({
    color: colors.scorpion,
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    lineHeight: lineHeight.default,
    padding: shorthandHelper([spacing.small, 42, spacing.small, spacing.default]),
    appearance: 'none',
    border: 'none',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    borderRadius: borderRadius.default,

    [mediaQueryHelper(breakpoint.tablet)]: {
      fontSize: fontSize.default,
    },

    '&::placeholder': {
      color: colors.grayChateau,
      userSelect: 'none',
    },

    '&[type="email"]': {
      fontSize: fontSize.default,
      color: colors.scorpion,
    },

    '&[readonly]': {
      backgroundColor: colors.catskillWhite,
      color: colors.jumbo,
    },

    '&:focus': {
      outline: 'none',
    },
  }),

  icon: css({
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    padding: shorthandHelper([0, spacing.default]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
}

export default styles

export const wrapperTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    '&:focus-within': {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`,
    },
  })
}
